module.exports = __webpack_public_path__ + "static/media/birthday.53b7acbe.jpg";